export default __webpack_public_path__ + "static/media/294.591a7c47.jpg";